import React, { useCallback } from "react";
import { Link, Typography } from "@mui/joy";
import { useDownloadDocument } from "../services/api";

interface BackgroundDocumentCompletionProps {
  workspaceId: string;
  status: "pending" | "running" | "completed" | "failed" | "cancelled";
  documentId?: string;
  documentTitle?: string;
  error?: string;
}

const BackgroundDocumentCompletion: React.FC<
  BackgroundDocumentCompletionProps
> = ({ workspaceId, status, documentId, documentTitle, error }) => {
  const downloadDocument = useDownloadDocument();
  const canDownload = Boolean(workspaceId && documentId && documentTitle);

  const handleDownload = useCallback(() => {
    if (!workspaceId || !documentId || !documentTitle) return;
    void Promise.resolve(
      downloadDocument(workspaceId, documentId, documentTitle),
    ).catch((error) =>
      console.error("Failed to download created document", error),
    );
  }, [documentId, documentTitle, downloadDocument, workspaceId]);

  return (
    <Typography data-testid="background-document-created" level="body-sm">
      {status === "failed" || status === "cancelled" ? (
        error || "Document creation failed"
      ) : status !== "completed" ? (
        "Creating…"
      ) : (
        <>
          Created
          {canDownload ? (
            <>
              {": "}
              <Link component="button" role="link" onClick={handleDownload}>
                {documentTitle}
              </Link>
            </>
          ) : null}
        </>
      )}
    </Typography>
  );
};

export default BackgroundDocumentCompletion;
